import { AiSuggestionKind } from '@/types/schema';

// These are the suggestion kind enums that we support suggestable inputs for.
export const SUGGESTABLE_KINDS = [
  AiSuggestionKind.JurisdictionStateCode,
  AiSuggestionKind.LegalName,
  AiSuggestionKind.GstStatus,
  AiSuggestionKind.EffectiveDate,
  AiSuggestionKind.CrummeyWithdrawalPeriodDays,
  AiSuggestionKind.DoingBusinessAsName,
  AiSuggestionKind.FincenId,
  AiSuggestionKind.TaxId,
  AiSuggestionKind.BusinessEntityTaxStatus,
  AiSuggestionKind.BeneficialOwnersAsOfDate,
  // Subtrust basic info suggestable kinds
  AiSuggestionKind.SubtrustGstStatus,
  // Note: SubtrustCreatedFrom is not a simple suggestable kind because it targets
  // an array field and requires KG statement resolution before appending the entity ID.
] as const;

export type SuggestableKind = (typeof SUGGESTABLE_KINDS)[number];

// These are the suggestion kind enums that we support matching suggestions for.
export const MATCHABLE_KINDS = [
  AiSuggestionKind.Principal,
  AiSuggestionKind.Trustee,
  AiSuggestionKind.SuccessorTrustee,
  AiSuggestionKind.TrustAdvisor,
  AiSuggestionKind.BeneficiaryV2,
  AiSuggestionKind.BeneficialOwner,
  AiSuggestionKind.KeyPerson,
  AiSuggestionKind.DpRecipientGrantor_1DiesFirst,
  AiSuggestionKind.DpRecipientGrantor_2DiesFirst,
  AiSuggestionKind.TeDpRecipientGrantor_1DiesFirst,
  AiSuggestionKind.TeDpRecipientGrantor_2DiesFirst,
  // Subtrust-form matchable kinds (rendered inside the subtrust modal via
  // TestamentaryEntitySuggestionsProvider).
  AiSuggestionKind.SubtrustTrustee,
  AiSuggestionKind.SubtrustSuccessorTrustee,
  AiSuggestionKind.SubtrustTrustAdvisor,
  AiSuggestionKind.SubtrustLifetimeBeneficiary,
  AiSuggestionKind.SubtrustRemainderBeneficiary,
] as const;

export type MatchableKind = (typeof MATCHABLE_KINDS)[number];

// List of AISuggestion kinds that are for Entity Details Forms.
// Excludes suggestions that are for onboarding, DP's, assets, etc.
// List of AISuggestion kinds that are related to Dispositive Provisions (DP).
// These suggestions don't need document precedence filtering.
export const DISPOSITIVE_PROVISION_SUGGESTION_KINDS = [
  AiSuggestionKind.DpRecipientGrantor_1DiesFirst,
  AiSuggestionKind.DpRecipientGrantor_2DiesFirst,
  AiSuggestionKind.TeDpRecipientGrantor_1DiesFirst,
  AiSuggestionKind.TeDpRecipientGrantor_2DiesFirst,
  AiSuggestionKind.DpDeathEventGrantor_1DiesFirst,
  AiSuggestionKind.DpDeathEventGrantor_2DiesFirst,
  AiSuggestionKind.DpRecipientTestamentaryEntity,
  AiSuggestionKind.DpRecipientV2,
];

// List of AISuggestion kinds that are related to AI Onboarding.
// These suggestions are created from the knowledge graph and do not belong to a single document.
export const AI_ONBOARDING_SUGGESTION_KINDS = [
  AiSuggestionKind.OnboardingEntity,
  AiSuggestionKind.OnboardingIndividual,
  AiSuggestionKind.OnboardingOrganization,
  AiSuggestionKind.OnboardingTestamentaryEntity,
];
